import { gql } from '@apollo/client';

const query = gql`
  query localsearchCMSArticles($categoryName: String, $size: Int) {
    localsearchCMSArticles(categoryName: $categoryName, size: $size) {
      results {
        article {
          articleTitle
          urlSlug
          featureImageUrl
          articleBlurb
          wordCount
          primaryCategoryName
          isQuotableCategory
          primaryCategoryId
        }
      }
      categoryFeatureImage
    }
  }
`;

module.exports = query;
